import type { ZekayCustomer } from "api/customers/Customer.typed";
import type { MultiComment } from "api/zekay/comments";
import { normalizeMultiComment } from "api/zekay/comments";
import type {
  ExcursionGroupCardClient,
  ExcursionGroupCardUser,
} from "../../../excursions/shared/utils/excursionPlanningTypes";

export type GroupWithLabels = {
  local_key: string;
  id?: number;
  users?: ExcursionGroupCardUser[];
  color?: string | null;
  comments?: MultiComment[];
  customers?: ExcursionGroupCardClient[];
  customer_id?: number | null;
  customer_label?: string;
  customer_last_name?: string;
  customer_first_name?: string;
  customer_qualification?: string;
  params?: Record<string, unknown>;
  paramsTemplateId?: number | null;
};

export function groupCustomersList(g: GroupWithLabels): ExcursionGroupCardClient[] {
  if (g.customers && g.customers.length > 0) return g.customers;
  if (g.customer_id != null) {
    return [
      {
        id: g.customer_id,
        first_name: g.customer_first_name,
        last_name: g.customer_last_name,
        qualification: g.customer_qualification,
        color: g.color ?? null,
      },
    ];
  }

  return [];
}

export function firstImportantComment(list: MultiComment[] | undefined): MultiComment | undefined {
  return list?.find((c) => c.Important === true);
}

/** When getExcursion replaces the list row object, preserve stable React keys for groups. */
export function mergeBuiltGroupsWithPrev(
  prev: GroupWithLabels[],
  built: GroupWithLabels[],
): GroupWithLabels[] {
  return built.map((g, idx) => {
    const prevG = prev[idx];
    const local_key = prevG?.local_key ?? g.local_key;

    return { ...g, local_key };
  });
}

export function groupCommentsToMultiComments(comments: MultiComment[] | undefined): MultiComment[] {
  if (!comments?.length) return [];

  return comments.map((c) => {
    const n = normalizeMultiComment(c);

    return {
      User: n.User || "Inconnu",
      Comment: n.Comment,
      Date: n.Date,
      ...(n.Important ? { Important: true } : {}),
    };
  });
}

export function newExcursionCreateCustomerDraft(): ZekayCustomer {
  return {
    FirstName: "",
    LastName: "",
    Birthdate: undefined as unknown as Date,
    Street: undefined,
    PostalCode: undefined,
    City: undefined,
    Phonenumber: undefined,
    MailAddress: undefined,
    GdprConsent: false,
    Photo: undefined,
    MedicalCertificate: undefined,
  };
}
